// extracted by mini-css-extract-plugin
export default {"CopiaCategory":"styles_CopiaCategory__99FDC","mapMode":"styles_mapMode__tgoAw"};